'use client';

/**
 * Post a message to the CURRENT active service worker.
 *
 * We deliberately do NOT use `window.serwist.messageSW` for the cache actions: serwist tracks
 * the worker it saw at registration time, and right after a new SW takes over via
 * `skipWaiting`/`clientsClaim` that reference can be stale — so `CACHE_IMAGES`/`CACHE_PAGES`
 * were intermittently delivered to a redundant worker (or nowhere), leaving the image cache
 * empty and the modal hung until its watchdog. Resolving `navigator.serviceWorker.ready` gives
 * the active worker at click time, which fixes the race.
 *
 * The SW replies via `clients.matchAll(...).postMessage(...)` (a broadcast the modals listen
 * for on `navigator.serviceWorker`), so we don't need a MessageChannel reply port here.
 *
 * Returns false if there's no service worker to post to (caller can decide how to proceed).
 */
export async function postToServiceWorker(message: unknown): Promise<boolean> {
    if (typeof navigator === 'undefined' || !navigator.serviceWorker) return false;
    try {
        const registration = await navigator.serviceWorker.ready;
        const sw = registration.active || navigator.serviceWorker.controller;
        if (!sw) return false;
        sw.postMessage(message);
        return true;
    } catch {
        return false;
    }
}

export default postToServiceWorker;
